import moment from "moment";
import React, { useEffect, useState } from "react";
import axios from "../../config/axiosInstance";
import { useQuery, useQueryClient } from "react-query";
import { CopyBlock, dracula } from "react-code-blocks";
import { API } from "../../config/apiConfig";
import DrawerLoading from "../DrawerLoading";

const AdminIntegrationSpecific = ({ companyId, isActive }) => {
  const queryClient = useQueryClient();

  const {
    isLoading: isLoadingToken,
    error: errorToken,
    data: token,
  } = useQuery(
    ["token", companyId],
    async () => {
      const data = await axios.get(`${API.GET_TOKEN}?companyId=${companyId}`);

      return data.data.token;
    },
    { enabled: isActive }
  );

  return (
    <div className="relative">
      {isLoadingToken && <DrawerLoading />}
      <div className="font-semibold text-sm mb-1">Token de integração:</div>
      {token && <CopyBlock text={token} theme={dracula} codeBlock />}
    </div>
  );
};

export default AdminIntegrationSpecific;
